import { render, staticRenderFns } from "./GetSubjectsRecordAxiosBySchool.vue?vue&type=template&id=ff35c02c&"
import script from "./GetSubjectsRecordAxiosBySchool.vue?vue&type=script&lang=js&"
export * from "./GetSubjectsRecordAxiosBySchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports